import React, {useState} from 'react';
import {
	PrimaryButtonCompat as PrimaryButton,
	SpinnerCompat as Spinner,
	IButtonProps,
} from 'components/FluentUICompat';

export interface ActionButtonProps extends IButtonProps {
	onClick: () => Promise<void>;
	children: React.ReactNode;
}

export const ActionButton = ({
	onClick,
	children,
	...props
}: ActionButtonProps) => {
	const [isLoading, setIsLoading] = useState(false);
	const handleClick = async () => {
		setIsLoading(true);

		await onClick();

		setIsLoading(false);
	};

	return (
		<PrimaryButton disabled={isLoading} onClick={handleClick} {...props}>
			{isLoading ? <Spinner /> : children}
		</PrimaryButton>
	);
};
